import * as actionTypes from "../actions/actionTypes";
import {updateObject} from "../../Utils/utils";

const initialState = {
    posts: [],
    loading: false,
    error: null,
    postSummitStatus: false
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.POST_INIT:
            return updateObject(state, {posts: [], postSummitStatus: false, error: null})
        case actionTypes.POST_START:
            return updateObject(state, {loading: true})
        case actionTypes.POST_SUCCESS:
            return updateObject(state, {posts: action.posts, loading: false})
        case actionTypes.POST_FAIL:
            return updateObject(state, {error: action.error, loading: false})
        case actionTypes.POST_TOGGLE_UPVOTE_SUCCESS:
            const postsListClone = [...state.posts]
            const postClone = {...postsListClone[action.id - 1]}
            const point = action.flag ? -1 : 1
            postClone.points = +postClone.points + point
            postsListClone[action.id - 1] = postClone
            return updateObject(state, {posts: postsListClone})
        case actionTypes.POST_SUBMIT_INIT:
            return updateObject(state, {loading: false, postSummitStatus: false, error: null})
        case actionTypes.POST_SUBMIT_START:
            return updateObject(state, {loading: true, postSummitStatus: false, error: null})
        case actionTypes.POST_SUBMIT_SUCCESS:
            return updateObject(state, {loading: false, postSummitStatus: true, error: null})
        case actionTypes.POST_SUBMIT_FAIL:
            return updateObject(state, {loading: false, postSummitStatus: false, error: action.error})
        case actionTypes.POST_COMMENT_SUBMIT_SUCCESS:
            return updateObject(state, {posts: [{...state.posts[0], comments: state.posts[0].comments + 1}]})
        default:
            return state
    }
}

export default reducer;